// extracted by mini-css-extract-plugin
module.exports = {"appear":"ConceptOverlay_appear__2oB8k","fadeIn":"ConceptOverlay_fadeIn__2KKIo","disappear":"ConceptOverlay_disappear__1rIjR","fadeOut":"ConceptOverlay_fadeOut__2TJvA"};